<template>
  <span>
    <img
      class="overflow-hidden rounded-sm"
      :src="src"
      :alt="phoneCountry"
      width="32px"
    />
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { StripePhonePlanProductItemPhoneCountryEnum } from '@mailslurp/admin-sdk';

const props = defineProps<{
  phoneCountry: StripePhonePlanProductItemPhoneCountryEnum;
}>();
const src = computed(() => {
  const p = props.phoneCountry;
  switch (p) {
    case StripePhonePlanProductItemPhoneCountryEnum.US:
      return '/flags/us.svg';
    case StripePhonePlanProductItemPhoneCountryEnum.GB:
      return '/flags/gb.svg';
    case StripePhonePlanProductItemPhoneCountryEnum.AU:
      return '/flags/au.svg';
    default:
      throw new Error('Unexpected value for phoneCountry.');
  }
});
</script>
